var module = angular.module('octopusApp.infrastructure');

$(function() {
  var clearVariableListings = function() {
    $(".variable-listing").remove();
  };

  $(document).on("click", clearVariableListings);
});

module.directive("insertVariableButton", function ($compile, octopusRepository, busy) {
  var template = [];
  template.push("<button class='btn btn-link no-margin no-padding no-border' type='button' title='Insert a variable'><em class='insert-variable-button-img'></em></button>");

  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: template.join(""),
    scope: {
      projectId: '=',
      projectEnvironmentsFilter: '=',
      localNames: '=',   // Optional list of additional variable names to show
      syntax: '@',       // octopus, powershell, bash or csharp
      ngSyntax: '=',     // (binding-friendly version of the above)
      insert: '=',       // insert(text) or null to use sibling textarea
      rebind: '@'        // unsatisfactory, but required to cause ngModel to update
    },
    link: function (scope, element, attrs) {

      var insert = function(text) {

        var textBox = scope.rebind ? angular.element(scope.rebind) : $("input[type='text'], textarea", element.parents(".bound-field")).not(".ui-select-focusser, .select2-input").first();

        var newValue;
        if (scope.insert) {
          newValue = scope.insert(text);
        } else {
          newValue = textBox.val() + text;
          textBox.val(newValue);
        }

        var ctrl = textBox.controller('ngModel');
        if (ctrl) {
          ctrl.$setViewValue(newValue);
        }
        textBox.focus();
      };

      var getSyntax = function() {
        return (scope.ngSyntax || scope.syntax || 'octopus').toLowerCase();
      };

      var delimit = function(varname) {
        var syntax = getSyntax();

        if (syntax === 'octopus') {
          return "#{" + varname + "}";
        }

        // Some escaping is probably required here.

        if (syntax === 'powershell') {
          if (varname.match(/^[A-z0-9]+$/)) {
            return "$" + varname;
          } else {
            return "$OctopusParameters['" + varname + "']";
          }
        }

        if (syntax === 'csharp') {
          return 'Octopus.Parameters["' + varname + '"]';
        }

        if (syntax === 'bash') {
          return '`get_octopusvariable "' + varname + '"`';
        }

        return varname;
      };

      element.click(function (e) {
        e.preventDefault();

        var childScope = scope.$new();

        childScope.searchText = "";
        childScope.names = [];
        childScope.functions = [];

        var isLoading = childScope.isLoading = busy.create();

        var text = [];
        text.push("<div class='variable-listing dynamic-popups'>");
        text.push("<div><spin active='isLoading.busy'></spin></div>");
        text.push("<div><error-box error='isLoading.error'></error-box></div>");
        text.push("<div ng-hide='isLoading.busy' class='variable-listing-toolbar form-search'><input class='search search-query' type='text' placeholder='Find...' ng-model='searchText' /></div>");
        text.push("<div ng-hide='isLoading.busy' class='variable-listing-items'>");
        text.push("<div ng-repeat='name in names | filter:searchText'><a class='fixed' href='' ng-click='select(name)'>{{ name }}</a></div>");
        text.push("<hr ng-show='functions.length > 0' />");
        text.push("<div ng-repeat='func in functions | filter:searchText'><a class='fixed function' href='' ng-click='selectFunction(func)'>{{ func }}</a></div>");
        text.push("</div>");
        text.push("</div>");

        var html = $compile(text.join(""))(childScope);

        childScope.select = function(name) {
          if (name) {
            html.remove();
            insert(delimit(name));
          }
        };

        childScope.selectFunction = function(func) {
          if (func) {
            html.remove();
            insert(func);
          }
        };

        $(".search", html).keyup(function(e){
          if(e.keyCode === 13) {
            var val = _.find(childScope.names, function (n) { return n.toLocaleLowerCase().indexOf(childScope.searchText.toLocaleLowerCase()) >= 0; });
            if (val) {
              childScope.select(val);
            }
          }
        });

        html.click(function (e) {
          e.preventDefault();
          return false;
        });

        childScope.$digest();

        var parent = $("body");
        var refPos = element.offset();
        var refHeight = element.outerHeight();
        var refWidth = element.outerWidth();
        var leftOffset = (parent.outerWidth() - refPos.left) < 240 ? 480 : 240;

        html.css({
          "position": "absolute",
          "left": (refPos.left - leftOffset) + "px",
          "top": (refPos.top + refHeight) + "px"
        });

        $(".dynamic-popups").remove();

        parent.append(html);

        isLoading.promise(octopusRepository.Variables.names(scope.projectId, scope.projectEnvironmentsFilter).then(function (values) {
          if (scope.localNames) {
            childScope.names = _.clone(scope.localNames);
          }

          for (var i = 0; i < values.length; i++) {
            childScope.names.push(values[i]);
          }

          if (getSyntax() === 'powershell') {
            childScope.functions.push('New-OctopusArtifact');
            childScope.functions.push('Set-OctopusVariable');
          }

          $(".search", html).focus();
        }));

        return false;
      });

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/insert_variable_button.js
// module id = 7452600292651205
// module chunks = 1